import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { AuthCredentialsContext, type AuthCredentials } from './auth-credentials-context'

export function AuthCredentialsProvider() {
  const [credentials, setCredentials] = useState<AuthCredentials>({ email: '', password: '' })

  return (
    <AuthCredentialsContext.Provider value={{ credentials, setCredentials }}>
      <Outlet />
    </AuthCredentialsContext.Provider>
  )
}
